export default __webpack_public_path__ + "static/media/user.84de6650.svg";